module.exports = __webpack_public_path__ + "img/ic_legal_info.21310980.svg";